import { PropsWithChildren, Suspense } from 'react';
import { Route } from 'react-router-dom';
import Loading from './Loading';

export default function LazyRoute({ children, path }: PropsWithChildren<{ path: string }>) {
    return (
        <Route path={path}>
            <Suspense fallback={<Loading />}>{children}</Suspense>
        </Route>
    );
}
